import { Loader2 } from 'lucide-react';
import { useEffect, useState } from 'react';

function Loader({
  title = 'Just a moment! 😊',
  description = 'Please wait, This will not take long...',
  interval = 3000,
}: {
  title?: string;
  description?: string | string[];
  interval?: number;
}) {
  const [currentDescIndex, setCurrentDescIndex] = useState(0);
  const descriptions = Array.isArray(description) ? description : [description];

  useEffect(() => {
    if (descriptions.length <= 1) return undefined;

    const rotateDescription = () => {
      setCurrentDescIndex((prev) => (prev + 1) % descriptions.length);
    };

    const timer = window.setInterval(rotateDescription, interval);

    return () => {
      window.clearInterval(timer);
    };
  }, [descriptions.length, interval]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <div className="w-20 h-20 mx-auto">
          <Loader2 className="w-16 h-16 animate-spin text-primary" />
        </div>
        <h3 className="text-2xl font-semibold">{title}</h3>
        <p className="text-muted-foreground">
          {descriptions[currentDescIndex]}
        </p>
      </div>
    </div>
  );
}

export default Loader;
